<div class="wa-stack wa-gap-xl">
  @if (survey.hasValue()) {
    <div class="wa-heading-xl">Assignments for {{ survey.value().name }}</div>
  } @else {
  <wa-callout variant="warning">
    <wa-icon slot="icon" name="triangle-exclamation" variant="regular"></wa-icon>
    <strong>No valid semester has been selected.</strong><br/>
    Please <a href="/home">return to the main page</a> to select a valid semester first.
  </wa-callout>
}

  <wa-tab-group>
    <wa-tab panel="exams">Exams</wa-tab>
    <wa-tab panel="staff">Staff</wa-tab>

    <wa-tab-panel name="exams">
      @if (survey.hasValue() && user?.isAdmin) {
        <app-exam-list
          [user]="user"
          [survey]="survey.value()!">
        </app-exam-list>
      }
    </wa-tab-panel>

    <wa-tab-panel name="staff">
      @if (survey.hasValue() && user?.isAdmin) {
        <app-staffmember-list
          [user]="user"
          [survey]="survey.value()!">
        </app-staffmember-list>
      }
    </wa-tab-panel>

  </wa-tab-group>
</div>
